import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ModalItemCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tagSelected: [],
      error: null
    }
  }

  componentWillReceiveProps(nextProps) {
    const tagSelected = [];

    // si se esta haciendo una edicion, se obtienen los tags seleccionados
    if (this.props.config) {
      if (this.props.config.tags !== nextProps.config.tags) {
        nextProps.config.tags.map((tag) => {
          const findTag = this.props.category.tags.find((item) => item.tag === tag);
          if (findTag) {
            tagSelected.push(tag);
          }
        });
    
        this.setState({
          tagSelected
        });
  
        // ejecuta varios eventos cuando se cambia el estado de los tags seleccionados
        this.updateStateChange(tagSelected);
      }
    }
  }

  handleSelect = (event) => {
    let tagSelected = [];
    const element = event.target;
    const value = element.innerText;
    element.classList.toggle('select');

    // ----------------------------------------------------------
    // si es multiple, entonces puede seleccionar mas de un item
    if (this.props.isMultiple) {
      // si esta seleccionado, lo agrega a la lista
      if (element.classList.contains('select')) {
        tagSelected = [...this.state.tagSelected, value]
      } else {
        // si lo desmarca, lo quita de la lista
        tagSelected = this.state.tagSelected.filter((tag) => tag !== value);
      }
    } else {
      // ----------------------------------------------------------
      // si NO es multiple, selecciona solo un item
      if (element.classList.contains('select')) {
        tagSelected.push(value);
      }
    }

    this.setState({
      tagSelected
    });

    // ejecuta varios eventos cuando se cambia el estado de los tags seleccionados
    this.updateStateChange(tagSelected);
  };

  updateStateChange = (tagSelected) => {
    setTimeout(() => {
      // notifica los tags seleccionados al padre
      this.notifyChange(tagSelected);

      // si no es multiple, valida que solo se haya seleccionado un solo item
      if (!this.props.isMultiple) {
        this.validateTagSelected();
      }
    }, 500);
  }

  validateTagSelected = () => {
    let error = null;

    if (this.state.tagSelected.length > 1) {
      error = {
        category: this.props.category.name,
        tagSelected: this.state.tagSelected,
        message: this.props.language.account.others.shouldSelectOnlyOneItem
      };
    }

    this.setState({
      error
    });

    // envia los errores al componente padre
    this.props.handleErrors(this.props.category.name, error);
  }

  notifyChange = (tagSelected) => {
    const payload = {
      category: this.props.category.name,
      tagSelected
    };

    this.props.handleChange(payload);
  }

  render() {
    return (
      <div className="box-form islabel">
        <div>
          <label className="modal-label">
            {this.props.language.filter[this.props.category.name.toLowerCase()]}

            {
              (this.state.error) && (
                <span className="text-error ml-1">{this.state.error.message} ({this.props.language.account.others.has} {this.state.error.tagSelected.length})</span>
              )
            }
          </label>
        </div>
        <div>
          {(this.props.action === 'create') && (
            <ul className="multiple-select" data-list={`list-${this.props.index}`}>
              {this.props.category.tags.map((item, e) => (
                <li
                  className={this.state.tagSelected.includes(item.tag) ? 'select' : ''}
                  onClick={this.handleSelect}
                  data-parent={`list-${this.props.index}`}
                  id={`list-${this.props.index}-${e}`}
                  key={`list-${this.props.index}-${e}`}
                >
                  {item.tag}
                </li>
              ))}
            </ul>
          )}

          {(this.props.action === 'update') && (
            <ul className="multiple-select" data-listup={`list-${this.props.index}`}>
              {this.props.category.tags.map((item, e) => {
                if (this.props.config.id) {
                  return (
                    <li
                      className={this.state.tagSelected.includes(item.tag) ? 'select' : ''}
                      onClick={this.handleSelect}
                      data-parentup={`list-${this.props.index}`}
                      id={`listup-${this.props.index}-${e}`}
                      key={`list-${this.props.index}-${e}`}
                    >
                      {item.tag}
                    </li>
                  );
                }
              })}
            </ul>
          )}
        </div>
      </div>
    );
  }
}

ModalItemCategories.propTypes = {
  isMultiple: PropTypes.bool,
};

ModalItemCategories.defaultProps = {
  isMultiple: false,
};

export default ModalItemCategories;



// WEBPACK FOOTER //
// ./source/client/components/common/forms/modalItemCategories.jsx